import { render, staticRenderFns } from "./QuotationStatistics.vue?vue&type=template&id=475e0fcc&scoped=true&"
import script from "./QuotationStatistics.vue?vue&type=script&lang=js&"
export * from "./QuotationStatistics.vue?vue&type=script&lang=js&"
import style0 from "./QuotationStatistics.vue?vue&type=style&index=0&id=475e0fcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e0fcc",
  null
  
)

export default component.exports